import type { Panorama } from '../../providers/types';

export interface PanoramaControls {
  zoomIn(): void;
  zoomOut(): void;
  /** Turns the view towards an absolute heading (degrees from north). */
  faceHeading(heading: number): void;
  /** Downloads a neighbouring panorama in advance (sphere viewer only). */
  preload?(panorama: Panorama): void;
  /**
   * Screen position of a point seen towards an absolute heading (degrees from north),
   * `pitchDeg` below/above the horizon, or null when it is out of view (sphere viewer only).
   */
  project?(headingDeg: number, pitchDeg: number): { x: number; y: number } | null;
}

/** Starts downloading the 360° viewer (three.js) before it is needed. */
export function preloadSphereViewer(): void {
  void import('./SphereViewer');
}
